import styles from "./ExpertRootPage.module.scss";
import { TableLabels } from "./TableLabels";
import { TableBody } from "./TableBody/TableBody";
import { useState } from "react";
import { Loader } from "@/frontend/shared/ui/Loader/Loader";
import { TCompany } from "../../DashboardPage/const/const";
import { useQuery } from "@tanstack/react-query";
import { reportErrorToSentry } from "@/frontend/shared/lib/reportErrorToSentry/reportErrorToSentry";
import { useMe } from "@/frontend/shared/lib/hooks/useMe";
import { ERoleAccess } from "@/frontend/app/providers/router/config/routeConfig";
import { ExpertDashboardHeader } from "@/frontend/widgets/ExpertDashboardHeader";
import { getOrganizations } from "../../ExpertPortfolioCompanyProfilePage/model/services/getOrganizations";
import { useLocation } from "react-router-dom";
import { extractOrganizationId } from "@/frontend/shared/lib/extractOrganizationId/extractOrganizationId";
import { InnoveraCompanyHeader } from "@/frontend/components/InnoveraCompanyHeader";
import { EContent } from "@/frontend/components/DashboardHeader/types/types";
import { getExpertOrganizationById } from "@/frontend/entities/Expert/services/model/getExpertOrganizationById";

export function ExpertRootPage() {
  const { data: userData, isLoading: isLoadingUserData } = useMe();

  const userRole = userData?.entity;

  const {
    data: organizations,
    isLoading: isLoadingOrganizations,
    isSuccess: isSuccessOrganizations
  } = useQuery({
    queryKey: ["expert/organizations"],
    queryFn: getOrganizations,
    initialData: [],
    throwOnError: (error) => {
      console.error(error);

      reportErrorToSentry(error, "EXPERT ROOT PAGE: /experts/organizations");
      return true;
    }
  });

  const [selectedRowIds, setSelectedRowIds] = useState<number[]>([]);
  const { pathname } = useLocation();

  const currentOrganizationId = extractOrganizationId(pathname) || organizations?.[0]?.id;

  const [page, setPage] = useState(1);

  const {
    data,
    isFetching,
    refetch,
    isLoading: isLoadingData
  } = useQuery({
    queryKey: ["organizationData", currentOrganizationId],
    queryFn: () => getExpertOrganizationById(currentOrganizationId!),
    refetchOnWindowFocus: false,
    enabled: !!userData && userRole === ERoleAccess.EXPERT && isSuccessOrganizations && currentOrganizationId != null,
    throwOnError: (error) => {
      console.error(error);

      reportErrorToSentry(error, "EXPERT ROOT PAGE: /experts/organizations");
      return true;
    }
  });

  function triggerRefetch() {
    refetch();
  }

  const allCompanyIds = data?.portfolioCompanies?.map((item: TCompany) => item.id);

  switch (true) {
    case isLoadingUserData || isLoadingOrganizations:
      return (
        <div className={styles.loaderContainer}>
          <Loader />
        </div>
      );
    default:
      return (
        <div className={styles.wrapper}>
          <InnoveraCompanyHeader activeContent={EContent.DASHBOARD} />
          <ExpertDashboardHeader />
          <div className={styles.contentTableBlock}>
            <TableLabels value={selectedRowIds.length === allCompanyIds?.length && selectedRowIds.length > 0} />
            <TableBody
              data={data || []}
              triggerRefetch={triggerRefetch}
              setPage={setPage}
              limit={data?.portfolioCompanies?.length || 0}
              currentPage={page}
              isLoading={isFetching}
              organizationId={currentOrganizationId || 0}
            />
          </div>
        </div>
      );
  }
}
